"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringRange = exports.Range = void 0;
var _lodash = require("lodash");
var _testing = require("../utils/testing");
var _conversions = require("../utils/conversions");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MIN_INTEGER = 0;
var MAX_INTEGER = 2147483647;
var nullIfTooBig = victim => victim == null || victim > MAX_INTEGER ? null : victim;
var nullIfTooSmall = victim => victim == null || victim < MIN_INTEGER ? null : victim;
var clampValue = value => (0, _lodash.isNumber)(value) ? nullIfTooBig(nullIfTooSmall(value)) : value;
var getFinalValue = value => clampValue((0, _conversions.toIntegerOrNull)(value));
class BaseRange {
  constructor(min, max) {
    _defineProperty(this, "min", void 0);
    _defineProperty(this, "max", void 0);
    this.min = min || null;
    this.max = max || null;
  }
  isRange() {
    return true;
  }
  isEmpty() {
    return this.min === null && this.max === null;
  }
  getObject() {
    return {
      min: this.min,
      max: this.max
    };
  }
  getSingleValue() {
    return this.min === this.max ? this.min : null;
  }
  static isInstance(value) {
    return (0, _testing.isA)(value, 'Range');
  }
}
class Range extends BaseRange {
  constructor(rangeOrArrayParam) {
    var rangeOrArray = rangeOrArrayParam || {};
    var range = (Array.isArray(rangeOrArray) ? [rangeOrArray[0], rangeOrArray[1]] : [rangeOrArray.min, rangeOrArray.max]).map(value => getFinalValue(value));
    super(range[0], range[1]);
  }
  static fromUrlParameter(value) {
    if (!value || typeof value !== 'string') {
      return undefined;
    }
    var values = value.split('-').map(each => parseInt(each, 10));
    return new Range([values[0], values.length > 1 ? values[1] : values[0]]);
  }
}
exports.Range = Range;
_defineProperty(Range, "MAX_INTEGER", MAX_INTEGER);
_defineProperty(Range, "MIN_INTEGER", MIN_INTEGER);
class StringRange extends BaseRange {
  constructor(rangeOrArrayParam) {
    var rangeOrArray = rangeOrArrayParam || {};
    var range = (Array.isArray(rangeOrArray) ? [rangeOrArray[0], rangeOrArray[1]] : [rangeOrArray.min, rangeOrArray.max]).map(value => typeof value === 'string' ? value : null);
    super(range[0], range[1]);
  }
  static isInstance(value) {
    return (0, _testing.isA)(value, 'Range');
  }
}
exports.StringRange = StringRange;